import { ShieldCheck, Leaf, Zap, Heart } from "lucide-react";

const ICONS = { ShieldCheck, Leaf, Zap, Heart };

const items = [
  { label: "Professional Team", desc: "Vetted & insured", icon: "ShieldCheck" },
  { label: "Eco-Friendly Products", desc: "Family & pet safe", icon: "Leaf" },
  { label: "Fast Service", desc: "Same-week openings", icon: "Zap" },
  { label: "Satisfaction Focused", desc: "100% care guarantee", icon: "Heart" },
];

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {items.map((it, i) => {
            const Icon = ICONS[it.icon];
            return (
              <div
                key={i}
                data-testid={`trust-item-${i}`}
                className="group flex items-start gap-3"
              >
                <div className="shrink-0 w-11 h-11 rounded-xl bg-gradient-to-br from-blue-600 to-sky-500 text-white flex items-center justify-center shadow-glow-soft group-hover:shadow-glow-blue transition-all duration-500">
                  <Icon className="w-5 h-5" strokeWidth={1.7} />
                </div>
                <div>
                  <div className="text-sm font-semibold text-slate-900">{it.label}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{it.desc}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
